import { RootState } from '../types';
import { storeResources } from '../resources';
import { INotification } from './types';

export const NotificationsSelector = (state: RootState): INotification[] =>
  state[storeResources.NOTIFICATIONS].notifications;
